// extracted by mini-css-extract-plugin
export default {"spacing":"AnalyticReportsSkeleton_spacing__P9lAx","flexClass":"AnalyticReportsSkeleton_flexClass__mtxqt","filtersRow":"AnalyticReportsSkeleton_filtersRow__fzzuN"};